"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "className", "colorScheme", "compact", "icon", "invertScheme"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: _objectSpread(_objectSpread(_objectSpread({}, theme.typography.extraSmallText), theme.mixins.truncate), {}, {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '.15rem .5rem',
      background: theme.colors.ashGrey,
      borderRadius: theme.variables.borderRadiusSmall,
      color: theme.colors.white,
      textAlign: 'center',
      textTransform: 'capitalize',
      verticalAlign: 'top',
      fontWeight: 500
    }),
    icon: {
      display: 'inline-flex',
      marginRight: '.25rem',
      fontSize: '1.25em' // Icon size relative 1.25em relative to badge parent
    },
    colorScheme: theme.mixins.colorScheme,
    invertScheme: theme.mixins.invertScheme,
    compact: {
      padding: '.05rem .5rem',
      fontSize: '0.685rem'
    }
  };
});
/*:: type Props = {
  children: React.Node,
  className?: string,
  colorScheme?: string,
  compact?: boolean,
  icon?: React.Node,
  invertScheme?: boolean
};*/
var Badge = function Badge(_ref /*:: */) {
  var children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    colorScheme = _ref /*:: */.colorScheme,
    compact = _ref /*:: */.compact,
    icon = _ref /*:: */.icon,
    invertScheme = _ref /*:: */.invertScheme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, invertScheme ? classes.invertScheme : classes.colorScheme, true), (0, _defineProperty2.default)({}, classes.compact, compact), className),
    "data-color": colorScheme || undefined
  }, props), icon && /*#__PURE__*/React.createElement("span", {
    className: classes.icon
  }, icon), children);
};
Badge.displayName = 'Badge';
Badge.defaultProps = {
  compact: false
};
var _default = exports.default = Badge;
//# sourceMappingURL=Badge.js.map